import { createLogic } from 'redux-logic'
import { map, catchError } from 'rxjs/operators'
import * as constants from '../constants'
import { throwError } from 'rxjs'
import User from '@engine/user'

export const getMapProjects = createLogic({
    type: constants.GET_MAP_PROJECTS.ACTION,
    processOptions: {
        successType: constants.GET_MAP_PROJECTS.FULFILLED,
        failType: constants.GET_MAP_PROJECTS.REJECTED
    },
    process({ http, getState }) {
        const state = getState()
        const createdUserGuid = User.selectors.user.entityUserGuid(state)

        return http
            .post('/maps/maps/getAllMaps',
                {
                    data: {
                        userId: createdUserGuid, limit: state.comps.comps.mapsPagination.limit,
                        offset: state.comps.comps.mapsPagination.offset,
                        recentProjectsOffset: 0
                    }
                }
            )
            .pipe(
                map(http.getBody),
                catchError(err => throwError(err))
            )
    }
})
